<form class="actionbar">
  <div class="bar-wrapper">
    <i class="far fa-search"></i>
    <input class="search" type="text" [placeholder]="'SEARCH'| translate" [formControl]="searchControl" />
  </div>
  <a class="new-questionnaire" routerLink="../questionnaires/new">{{'NEW_VITALITY_SCAN' | translate}}</a>
</form>

<table [cellSpacing]="0">
  <thead>
    <tr>
      <th *ngIf="userRole === 'ADMIN' || userRole === 'SUPERADMIN'">{{'SENDER' | translate}}</th>
      <th *ngIf="userRole === 'SUPERADMIN'">{{'COMPANY' | translate}}</th>
      <th>{{'RECIPIENT' | translate}}</th>
      <th>{{'PHONE_NUMBER' | translate}}</th>
      <th>{{'SEND_AT' | translate}}</th>
      <th>{{ 'STATE' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr [class.hover-able]="questionnaire.session !== null" *ngFor="let questionnaire of questionnaires" (click)="toResult(questionnaire)">
      <td *ngIf="userRole === 'ADMIN' || userRole === 'SUPERADMIN'">
        {{ questionnaire.createdBy.firstName + ' ' + questionnaire.createdBy.lastName }}
      </td>
      <td *ngIf="userRole === 'SUPERADMIN'">{{ questionnaire.createdBy.tenant.name }}</td>
      <td>{{ questionnaire.clientFirstName + ' ' + questionnaire.clientLastName }}</td>
      <td>{{ questionnaire.phoneNumber }}</td>
      <td>{{ questionnaire.created | date: 'dd-MM-YYYY' }}</td>
      <td>{{ getStateText(questionnaire.state) }}</td>
    </tr>
  </tbody>
</table>
